import React, { useState } from 'react';
import { Phone, PlusCircle, Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'HOME',
    href: '/'
  }, {
    name: 'ABOUT US',
    href: '/about'
  }, {
    name: 'SERVICES',
    href: '/services'
  }, {
    name: 'APPOINTMENT REQUEST',
    href: '/appointment'
  }, {
    name: 'CONTACT US',
    href: '/contact'
  }];
  return <header className="w-full flex flex-col font-sans" data-id="element-123" data-mp="31bfd9hwx4z6t">
      {/* Top Utility Bar */}
      <div className="bg-slate-900 text-slate-300 py-2 px-4 text-sm" data-id="element-124" data-mp="36as7inq4d8jf">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-end items-center gap-4 sm:gap-6" data-id="element-125" data-mp="36d4l6oougwqo">
          <Link to="/appointment" className="flex items-center gap-1.5 hover:text-white transition-colors font-medium" data-id="element-126" data-mp="3b8bohve7bzf2">
            <PlusCircle className="w-4 h-4 text-[#b87333]" data-id="element-127" data-mp="2wlm7vbyte0iu" />
            REQUEST AN ESTIMATE
          </Link>
          <a href="tel:7146023634" className="flex items-center gap-1.5 hover:text-white transition-colors font-medium" data-id="element-128" data-mp="2rk6p5qk4063m">
            <Phone className="w-4 h-4 text-[#b87333]" data-id="element-129" data-mp="2ho3koe1sbvdi" />
            (714) 602-3634
          </a>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-[#0c2340] text-white shadow-md sticky top-0 z-50" data-id="element-130" data-mp="3fakf9bj4vuvk">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:py-6 flex justify-between items-center" data-id="element-131" data-mp="3adk9l1q74u4z">
          {/* Logo Area */}
          <Link to="/" className="flex items-center" data-id="element-132" data-mp="35jg30jkueo4f">
            <img src="https://cdn.magicpatterns.com/uploads/mLJdqn1YBuqHdE7DWNbtyp/pasted-image.webp" alt="A-Flow Seamless Rain Gutters" className="h-10 sm:h-14 w-auto" data-id="element-133" data-mp="30n7sjjhlbj3l" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-134" data-mp="1rdl5ommmps25">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href || location.pathname === '/' && link.href === '/';
            return <Link key={link.name} to={link.href} className={`text-sm font-semibold tracking-wide transition-colors py-2 border-b-2 ${isActive ? 'text-white border-[#b87333]' : 'text-slate-300 border-transparent hover:text-white hover:border-slate-500'}`} data-id="element-135" data-mp="1hlno8y5123uz">
                  {link.name}
                </Link>;
          })}
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-136" data-mp="13os2q67lajy1">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-137" data-mp="2y18grt6mn2dg" /> : <Menu className="w-6 h-6" data-id="element-138" data-mp="mdv7crlapwew" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && <nav className="lg:hidden bg-[#0a1c33] border-t border-slate-700" data-id="element-139" data-mp="hhegvqqmj5yn">
            <ul className="flex flex-col px-4 py-2" data-id="element-140" data-mp="w59d3h3ubsgh">
              {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <li key={link.name} data-id="element-141" data-mp="1544m10y9rgnh">
                    <Link to={link.href} onClick={() => setIsMobileMenuOpen(false)} className={`block py-3 text-sm font-semibold tracking-wide ${isActive ? 'text-[#b87333]' : 'text-slate-300'}`} data-id="element-142" data-mp="1578uiairoyjy">
                      {link.name}
                    </Link>
                  </li>;
          })}
            </ul>
          </nav>}
      </div>
    </header>;
}